import { render } from "./SpinnerContainer.vue?vue&type=template&id=eefffd84&scoped=true&ts=true"
import script from "./SpinnerContainer.vue?vue&type=script&lang=ts"
export * from "./SpinnerContainer.vue?vue&type=script&lang=ts"

import "./SpinnerContainer.vue?vue&type=style&index=0&id=eefffd84&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefffd84"]])

export default __exports__